module.exports = __webpack_public_path__ + "img/US_SplashDamageArmor_ua.ec0adbbb.webp";